import { defineComponent as e } from "vue";
const o = e({
  name: "LoadingBar",
  props: {
    message: {
      type: String,
      default: "Loading ..."
    },
    showOverlay: {
      type: Boolean,
      default: !0
    }
  }
});
export {
  o as default
};
//# sourceMappingURL=index3.js.map
